import { useState, useEffect } from 'react';

const useMdBreakpoint = (mdBreakpoint = 769) => {
  const [isMd, setIsMd] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia(`(min-width: ${mdBreakpoint}px)`);

    const handleMediaQueryChange = (event: any) => {
      setIsMd(event.matches);
    };

    setIsMd(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, [mdBreakpoint]);

  return isMd;
};

export default useMdBreakpoint;